import { IItemsFilterProps } from '../components/shared/filters/ItemsFilter';
import { ALLOWED_TRIBES, IAMPermission, IApplicationFull, IApplicationRecord, UserPermissions } from '../types';
import { capitalizeFirstLetter, formatPrice, isNumeric } from '../utils';
import { computeTribesPath } from './tribe';

export const getApiReadableState = (value: string | null): string => {
  switch (value) {
    case 'Decommissioned':
      return 'decommissioned';
    case 'Modernized':
      return 'modernized';
    case 'To be completed':
      return 'to_be_completed';
    case 'To be decommissioned':
      return 'to_be_decommissioned';
    case 'To be modernized':
      return 'to_be_modernized';
    default:
      return 'to_be_completed';
  }
};

export const getHumanReadableState = (value: string | undefined): string => {
  switch (value) {
    case 'decommissioned':
      return 'Decommissioned';
    case 'modernized':
      return 'Modernized';
    case 'to_be_completed':
      return 'To be completed';
    case 'to_be_decommissioned':
      return 'To be decommissioned';
    case 'to_be_modernized':
      return 'To be modernized';
    default:
      return 'To be completed';
  }
};

export const getLastRecord = (records: IApplicationRecord[] | undefined): IApplicationRecord | undefined => {
  if (typeof records === 'undefined' || !records || records.length === 0) {
    return undefined;
  }

  return records.reduce((prev, current) =>
    new Date(prev.createdDate) > new Date(current.createdDate) ? prev : current
  );
};

export const getLastRecordFull = (records: IApplicationFull[] | undefined): IApplicationFull | undefined => {
  if (typeof records === 'undefined' || !records || records.length === 0) {
    return undefined;
  }

  return records.reduce((prev, current) => (new Date(prev.recordDate) > new Date(current.recordDate) ? prev : current));
};

// TODO: implement 0.5
export const formatResult = (value: string): string => {
  switch (value) {
    case '0':
      return 'Not used';
    case '0.5':
      return 'Partially used';
    case '1':
      return 'Used';
    default:
      return isNumeric(value) ? formatPrice(Number(value)) : capitalizeFirstLetter(value);
  }
};

export const isUrlClean = (
  filterKey: string,
  param: (string | null)[] | null | undefined,
  filters: IItemsFilterProps[]
): boolean => {
  const options = filters.filter((item) => item.queryParamKey === filterKey).flatMap((filter) => filter.options);

  return typeof param !== 'undefined' && param !== null
    ? param.some((item) => options.map((option) => option?.key).includes(item as string))
    : false;
};

export const isTribeUrlClean = (param: (string | null)[] | null | undefined, filters: IItemsFilterProps[]): boolean => {
  const options = filters.filter((item) => item.queryParamKey === 'tribes').flatMap((filter) => filter.nodes ?? []);

  const tribeFilter = computeTribesPath(options);

  return typeof param !== 'undefined' && param !== null
    ? param.some((item) => tribeFilter.includes(item as string))
    : false;
};

export const cleanTribe = (param: (string | null)[] | null | undefined, filters: IItemsFilterProps[]) => {
  const options = filters.filter((item) => item.queryParamKey === 'tribes').flatMap((filter) => filter.nodes ?? []);

  const tribeFilter = computeTribesPath(options);
  return param?.filter((item) => item !== null && tribeFilter.includes(item));
};

export const formatDocumentationLink = (scopeRef: string, hasExtra?: boolean, info?: string): string => {
  const details = hasExtra ? `#${info}` : '';
  const computedScope = scopeRef === 'finops' ? 'cost' : scopeRef;
  return `${window.globalConfiguration.url.documentation}/${computedScope}.html${details}`;
};
